import { render, staticRenderFns } from "./dashboard-container-widget.vue?vue&type=template&id=33559f70&scoped=true"
import script from "./dashboard-container-widget.vue?vue&type=script&lang=js"
export * from "./dashboard-container-widget.vue?vue&type=script&lang=js"
import style0 from "./dashboard-container-widget.vue?vue&type=style&index=0&id=33559f70&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33559f70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33559f70')) {
      api.createRecord('33559f70', component.options)
    } else {
      api.reload('33559f70', component.options)
    }
    module.hot.accept("./dashboard-container-widget.vue?vue&type=template&id=33559f70&scoped=true", function () {
      api.rerender('33559f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/dashboard-container/dashboard-container-widget.vue"
export default component.exports